import styled from 'styled-components';
import { ActionButton } from './ActionButton.styled';

export const MenuButton = styled(ActionButton)`
    background-color: white;
    color: inherit;

    /* font */
    font-size: 16px;
    font-weight: 300;
`;
